'use client';

import type { ReactNode } from 'react';
import { HStack, VStack } from '@terra/ui-styled-system';
import type { ApplicationSettingsTabId } from '../../../store/application-settings-tab-id';
import {
  SettingsSubTabs,
  type SettingsSubTabItem,
} from '../layout/SettingsSubTabs';
import { useSettingsTabHeaderChildActions } from '../settingsTabHeaderContext';

type TargetSettingsSectionFrameProps = {
  activeSection: ApplicationSettingsTabId;
  onSectionChange: (section: ApplicationSettingsTabId) => void;
  subTabs: ReadonlyArray<SettingsSubTabItem<ApplicationSettingsTabId>>;
  fillHeight?: boolean;
  children: ReactNode;
};

export function TargetSettingsSectionFrame({
  activeSection,
  onSectionChange,
  subTabs,
  fillHeight = false,
  children,
}: TargetSettingsSectionFrameProps) {
  const actions = useSettingsTabHeaderChildActions();

  return (
    <VStack
      alignItems="stretch"
      gap={4}
      w="full"
      flex={fillHeight ? 1 : undefined}
      minH={fillHeight ? 0 : undefined}
    >
      {subTabs.length > 1 ? (
        <SettingsSubTabs
          value={activeSection}
          onValueChange={onSectionChange}
          items={subTabs}
          actions={actions}
        >
          {null}
        </SettingsSubTabs>
      ) : actions ? (
        <HStack justifyContent="flex-end" gap={2}>
          {actions}
        </HStack>
      ) : null}
      {children}
    </VStack>
  );
}
